export default "__VITE_ASSET__BXh1bdwd__"